@if(!show404msg()) {
    @if(reisen()?.elements) {
        <div class="reisen-wrapper">
            <app-contenteditor [datas]="reisen()"></app-contenteditor>
        </div>
    }
} @else {
<div class="cc2">
    <div class="cc1">
        <h2>Die Seite, die Sie suchen, existiert nicht.</h2>
        <h3 class="cc4">Starten Sie eine Suchanfrage oder <button class="cc3" (click)="gotostartsite()">zurück zur
                Übersichtsseite.</button></h3>
    </div>
</div>
}